import classNames from "classnames";
import Button from "@components/core/Button";
import CloseButton from "@components/core/CloseButton";

function SectionContent({
  isOpen,
  onClose,
  onGoBack,
  title,
  isSectionInsideSection = false,
  children,
}) {
  return (
    <div className={classNames("filters-section", isSectionInsideSection && "full-height", isOpen && "open")}>
      <div className="filters-section-header">
        <Button
          variant="ghost-dark"
          leftIconName="chevron-left"
          onClick={onGoBack}
        />
        <h5 className="mb-0">{title}</h5>
        <CloseButton onClick={onClose} />
      </div>

      <div className="filters-section-block">
        {children}
      </div>
    </div>
  );
}

export default SectionContent;